// extracted by mini-css-extract-plugin
export default {"info-panel":"HKSz","infoPanel":"HKSz"};